import { render, staticRenderFns } from "./FolderTagList.vue?vue&type=template&id=523a1984&scoped=true"
import script from "./FolderTagList.vue?vue&type=script&lang=js"
export * from "./FolderTagList.vue?vue&type=script&lang=js"
import style0 from "./FolderTagList.vue?vue&type=style&index=0&id=523a1984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523a1984",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VCardActions,VDivider,VList,VListItem})
